import { useCallback } from "react"

export default function useAppointmentOpenController({
  clinicId,
  events,
  setSelectedHeldEvent,
  setSelectedAppointment,
  setSelectedAppointmentTreatmentId,
  setFinancialSummary,
  setPatientSnapshot,
  setPatientOdontogram,
  setPaymentForm,
  setReceivableForm,
  resetTreatmentOdontogramForm,
  loadFinancialSummary,
  loadPatientSnapshot,
  loadPatientTreatmentPlans
}) {
  const handleCalendarEventClick = useCallback(async (info) => {
    if (String(info.event.id).startsWith("held-")) {
      setSelectedHeldEvent({
        id: String(info.event.id).replace("held-", ""),
        title: info.event.title,
        start: info.event.start,
        end: info.event.end,
        patientName: info.event.extendedProps?.patientName || info.event.title,
        doctorName: info.event.extendedProps?.doctorName || null,
        reason:
          info.event.extendedProps?.treatmentName ||
          info.event.extendedProps?.reason ||
          "Reserva temporal"
      })
      return
    }

    const resolvedClinicId =
      info.event.extendedProps?.clinicId && info.event.extendedProps?.clinicId !== "ALL"
        ? info.event.extendedProps?.clinicId
        : clinicId

    const appt = {
      id: info.event.id,
      title: info.event.title,
      start: info.event.start,
      end: info.event.end,
      patientId: info.event.extendedProps?.patientId,
      patientName: info.event.extendedProps?.patientName,
      doctorId: info.event.extendedProps?.doctorId,
      doctorName: info.event.extendedProps?.doctorName,
      chairId: info.event.extendedProps?.chairId,
      chairName: info.event.extendedProps?.chairName,
      treatmentId: info.event.extendedProps?.treatmentId,
      treatmentName: info.event.extendedProps?.treatmentName,
      reason: info.event.extendedProps?.reason,
      status: info.event.extendedProps?.status,
      source: info.event.extendedProps?.source,
      clinicName: info.event.extendedProps?.clinicName,
      planItemId: info.event.extendedProps?.planItemId || null,
      isPlanLinked: info.event.extendedProps?.isPlanLinked || false,
      clinicId: resolvedClinicId,

      // ✅ IMPORTANTE PARA QUE AL REABRIR CONSERVE EL ESTADO REAL
      checkedIn: Boolean(info.event.extendedProps?.checkedIn || info.event.checkedIn),
      checkedInTime:
        info.event.extendedProps?.checkedInTime ||
        info.event.checkedInTime ||
        null,

      // opcional pero útil para consistencia visual
      customTagColor:
        info.event.extendedProps?.customTagColor ||
        info.event.extendedProps?.markerColor ||
        null,
    }

    setSelectedAppointment(appt)
    setSelectedAppointmentTreatmentId(info.event.extendedProps?.treatmentId || "")
    setFinancialSummary(null)
    setPatientSnapshot(null)
    setPatientOdontogram(null)

    setPaymentForm({
      amount: "",
      method: "CASH",
      notes: ""
    })

    setReceivableForm({
      totalAmount: ""
    })

    resetTreatmentOdontogramForm()

    await loadFinancialSummary(info.event.id, resolvedClinicId)
    await loadPatientSnapshot(info.event.extendedProps?.patientId, resolvedClinicId)
    await loadPatientTreatmentPlans(info.event.extendedProps?.patientId, resolvedClinicId)
  }, [
    clinicId,
    setSelectedHeldEvent,
    setSelectedAppointment,
    setSelectedAppointmentTreatmentId,
    setFinancialSummary,
    setPatientSnapshot,
    setPatientOdontogram,
    setPaymentForm,
    setReceivableForm,
    resetTreatmentOdontogramForm,
    loadFinancialSummary,
    loadPatientSnapshot,
    loadPatientTreatmentPlans
  ])

  const openAppointmentFromActionPanel = useCallback(async (appointmentId) => {
    const event = events.find((e) => String(e.id) === String(appointmentId))
    if (!event) return

    const fakeInfo = {
      event: {
        id: event.id,
        title: event.title,
        start: event.start,
        end: event.end,
        checkedIn: event.checkedIn,
        checkedInTime: event.checkedInTime,
        extendedProps: event.extendedProps || {}
      }
    }

    await handleCalendarEventClick(fakeInfo)
  }, [events, handleCalendarEventClick])

  return {
    handleCalendarEventClick,
    openAppointmentFromActionPanel
  }
}